import type { SVGProps } from "react";

type NavIconProps = SVGProps<SVGSVGElement>;

function iconClassName(className: string | undefined, name: string): string {
  return [name, className].filter(Boolean).join(" ");
}

export function CompareNavIcon({ className, ...props }: NavIconProps) {
  return (
    <svg
      className={iconClassName(className, "nav-compare-icon")}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path className="nav-compare-top" d="m9 3-3 3 3 3M6 6h12" />
      <path className="nav-compare-bottom" d="m15 21 3-3-3-3M18 18H6" />
    </svg>
  );
}

export function ActivityNavIcon({ className, ...props }: NavIconProps) {
  return (
    <svg
      className={iconClassName(className, "nav-activity-icon")}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path
        className="nav-draw-path"
        d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"
      />
    </svg>
  );
}

export function NotificationsNavIcon({ className, ...props }: NavIconProps) {
  return (
    <svg
      className={iconClassName(className, "nav-bot-icon")}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12 8V4H8" />
      <rect width="16" height="12" x="4" y="8" rx="2" />
      <path d="M2 14h2" />
      <path d="M20 14h2" />
      <path className="nav-bot-eye" d="M15 13v2" />
      <path className="nav-bot-eye" d="M9 13v2" />
    </svg>
  );
}

export function PortfolioNavIcon({ className, ...props }: NavIconProps) {
  return (
    <svg
      className={iconClassName(className, "nav-portfolio-icon")}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path className="nav-portfolio-handle" d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      <rect className="nav-portfolio-case" width="18" height="14" x="3" y="7" rx="2" />
      <path className="nav-portfolio-latch" d="M3 12h18" />
    </svg>
  );
}

export function StatisticsNavIcon({ className, ...props }: NavIconProps) {
  return (
    <svg
      className={iconClassName(className, "nav-chart-icon")}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M3 3v16a2 2 0 0 0 2 2h16" />
      <path className="nav-draw-path" d="m19 9-5 5-4-4-3 3" />
    </svg>
  );
}

export function MarketsNavIcon({ className, ...props }: NavIconProps) {
  return (
    <svg
      className={iconClassName(className, "nav-market-icon")}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path className="nav-market-awning" d="M3 9l2-5h14l2 5" />
      <path className="nav-market-building" d="M5 9v11h14V9" />
      <path className="nav-market-door" d="M9 20v-6h6v6" />
    </svg>
  );
}

export function SupportIcon({ className, ...props }: NavIconProps) {
  return (
    <svg
      className={iconClassName(className, "support-message-icon")}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g className="support-message-group">
        <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
        <line className="support-message-dot support-message-dot-one" x1="16" y1="12" x2="16" y2="12" />
        <line className="support-message-dot support-message-dot-two" x1="12" y1="12" x2="12" y2="12" />
        <line className="support-message-dot support-message-dot-three" x1="8" y1="12" x2="8" y2="12" />
      </g>
    </svg>
  );
}
